import React from 'react';

const NotFound = () => {
  return (
    <div
      style={{
        display: 'flex',
        width: '100vw',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '50px',
        color: '#ff0000',
      }}
    >
      <p>Not found</p>
    </div>
  );
};

export default NotFound;
